import styles from './Faq.module.css';
import React from 'react'
import { Col, Container, Button,Accordion } from 'react-bootstrap';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import vec1 from '../../assets/icons/vec1.png';

import patricia from '../../assets/imgs/Patricia.png';
import asin5 from '../../assets/imgs/Decagon.png';
import kofoundme from '../../assets/icons/logo.png';
import bilaaw from '../../assets/imgs/Andela.png';
import glade from '../../assets/imgs/Flutterwave.png';
import knowtized from '../../assets/imgs/Busha.png';
import hostull from '../../assets/imgs/Barter.png';
import mi from '../../assets/imgs/Bolt.png';
import rlogo from '../../assets/imgs/rlogo.png';
// import zebullion from '../../assets/imgs/zebullon.png';









const responsive1 = {
  0: { items: 3 },
  568: { items: 5 },
  1024: { items: 5},
};

const items = [
  <div className="item" data-value="1">
  <img src={patricia} alt='patricia' className={`img-fluid ${styles.slider1}`} />
  </div>,
  <div className="item" data-value="2">
  <img src={asin5} alt='asin5' className={`img-fluid ${styles.slider1}`} />
  </div>,
    <div className="item" data-value="3">
    <img src={kofoundme} alt='kofoundme' className={`img-fluid ${styles.slider1}`} />
    </div>,
      <div className="item" data-value="4">
      <img src={bilaaw} alt='Billaaw' className={`img-fluid ${styles.slider1}`} />
      </div>,
        <div className="item" data-value="5">
        <img src={glade} alt='Glade' className={`img-fluid ${styles.slider1}`} />
        </div>,
         <div className="item" data-value="6">
         <img src={knowtized} alt='Glade' className={`img-fluid ${styles.slider1}`} />
         </div>,
            <div className="item" data-value="7">
            <img src={hostull} alt='hostull' className={`img-fluid ${styles.slider1}`} />
            </div>,
         <div className="item" data-value="8">
         <img src={mi} alt='Mi' className={`img-fluid ${styles.slider1}`} />
         </div>,
            <div className="item" data-value="9">
            <img src={rlogo} alt='R' className={`img-fluid ${styles.slider1}`} />
            </div>,
          // <div className="item" data-value="0">
          // <img src={zebullion} alt='zebullon' className={`img-fluid ${styles.slider1}`} />
          // </div>,

];


export const Faq = () => {
  return (
    <div>
<Container fluid className={`${styles.trustSec}`}>
  <Container>
    <div className={`${styles.trust}`}>
      <p className={` text-center fw-light ${styles.trustTitle}`}>200+ Businesses trust us with their website and mobile apps</p>
     <div className={`mt-4`}> <AliceCarousel
                            autoPlay
                            autoPlayControls
                            autoPlayStrategy="none"
                            autoPlayInterval={4000}
                            infinite
                            mouseTracking
                            items={items}
                            responsive={responsive1}
                            controlsStrategy="alternate"
                            disableButtonsControls
                            disableSlideInfo
                            
                        />
                        </div>

    </div>
  </Container>
</Container>



        <Container className={`${styles.section}`}>
            <Col lg={12} xs={12} sm={12} md={12} >
            <div className={` ms-lg-auto me-lg-auto ${styles.caption}`}>
                <h2 className={`${styles.title}`}> Need help with something?</h2>
                <p className={`${styles.desc}`}>  See our FAQs, it’s possible we already have an answer to your question.</p>

            </div>

            <div className={`${styles.faq}`}>
           <Accordion className={`border-0 ${styles.acc}`}>
  <Accordion.Item eventKey="0" className={`${styles.accItem}`}>
    <Accordion.Header className={`bg-white ${styles.accTitle}`}>What minimum amount I can bring to build a website?</Accordion.Header>
    <Accordion.Body className={`${styles.accbody}`}>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
      tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
      veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
      commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
      velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
      cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
      est laborum.
    </Accordion.Body>
  </Accordion.Item>

  <Accordion.Item eventKey="1" className={`${styles.accItem}`}>
    <Accordion.Header className={`${styles.accTitle}`}>Does this mean certain things will be missing from my webiste because 
of what i paid?</Accordion.Header>
    <Accordion.Body className={`${styles.accbody}`}>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
      tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
      veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
      commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
      velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
      cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
      est laborum.
    </Accordion.Body>
</Accordion.Item>

  <Accordion.Item eventKey="2" className={`${styles.accItem}`}>
    <Accordion.Header className={`${styles.accTitle}`}>Do I get to pick which developer designs my website?</Accordion.Header>
    <Accordion.Body className={`${styles.accbody}`}>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
      tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
      veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
      commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
      velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
      cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
      est laborum.
    </Accordion.Body>
  </Accordion.Item> 

  <Accordion.Item eventKey="3" className={`${styles.accItem}`}>
    <Accordion.Header className={`${styles.accTitle}`}>Since I am paying whatever I have, do I get a choice regarding features 
and functionalities?</Accordion.Header>
    <Accordion.Body className={`${styles.accbody}`}>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
      tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
      veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
      commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
      velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
      cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
      est laborum.
    </Accordion.Body>
  </Accordion.Item>  

   <Accordion.Item eventKey="4" className={`${styles.accItem}`}>
    <Accordion.Header className={`${styles.accTitle}`}>How long does it take for my website to be ready?</Accordion.Header>
    <Accordion.Body className={`${styles.accbody}`}>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
      tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
      veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
      commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
      velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
      cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
      est laborum.
    </Accordion.Body>
  </Accordion.Item>  

     <Accordion.Item eventKey="5" className={`${styles.accItem}`}>
    <Accordion.Header className={`${styles.accTitle}`}>How do I communicate with my service providers?</Accordion.Header>
    <Accordion.Body className={`${styles.accbody}`}>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
      tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
      veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
      commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
      velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
      cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
      est laborum.
    </Accordion.Body>
  </Accordion.Item>  

       <Accordion.Item eventKey="6" className={`${styles.accItem}`}>
    <Accordion.Header className={`${styles.accTitle}`}>Does ULLWEB redesign existing website too?</Accordion.Header>
    <Accordion.Body className={`${styles.accbody}`}>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
      tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
      veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
      commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
      velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
      cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
      est laborum.
    </Accordion.Body>
  </Accordion.Item> 

     <Accordion.Item eventKey="7" className={`${styles.accItem}`}>
    <Accordion.Header className={`${styles.accTitle}`}>Are there any hidden charges I should know about?</Accordion.Header>
    <Accordion.Body className={`${styles.accbody}`}>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
      tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
      veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
      commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
      velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
      cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
      est laborum.
    </Accordion.Body>
  </Accordion.Item>  

</Accordion>
            </div>
                    <Button variant='primary' className={`${styles.btn1}`} >See more FAQ    <img src={vec1} /></Button>

            
            </Col>
        </Container>
    </div>
  )
}
